module.exports = "/public/images/293a2ad71693dad02878341e4c0ed3a2.svg";